import type { HelpContent } from '../types'

/** Help panel + first-run walkthrough copy for the Dashboard. Em-dash free. */
export const DASHBOARD_HELP: HelpContent = {
  key: 'dashboard',
  title: 'Dashboard',
  intro:
    'The Dashboard is your results overview. It summarizes what your automation has done so far: leads in your pipeline, reply rate, meetings booked, and engagement on your posts, with recent activity below. It fills in once your campaigns are running.',
  panel: [
    {
      heading: 'What the numbers mean',
      items: [
        { term: 'Total Leads', text: 'Everyone in your pipeline across all stages and campaigns.' },
        { term: 'Reply Rate', text: 'The percent of contacted leads who have replied.' },
        { term: 'Meetings Booked', text: 'How many leads booked a meeting through your outreach.' },
        { term: 'Content Engagement', text: 'Total likes and comments your published posts have earned.' },
      ],
    },
    {
      heading: 'Reading the charts',
      items: [
        { term: 'Outreach Funnel', text: 'Each bar is an outreach stage. The percent between bars is how many people moved to the next stage.' },
        { term: 'Pipeline Overview', text: 'How your leads are split across pipeline stages, by count and share.' },
        { term: 'Activity Feed', text: 'A running log of what your automation did, newest first.' },
      ],
    },
    {
      heading: 'Pro panels',
      items: [
        {
          text: 'Strategy Performance, the activity chart, and Top Messages are Pro features. On the Basic plan they appear dimmed with an Upgrade button.',
        },
      ],
    },
    {
      heading: 'Getting started',
      items: [
        {
          text: 'Before you have data, the Dashboard shows a welcome card. Use Quick Actions to find leads, start a campaign, or draft a post.',
        },
      ],
    },
  ],
  tour: [
    {
      id: 'welcome',
      title: 'Your results overview',
      body: 'The Dashboard summarizes what your automation has done. It comes alive once your campaigns are running.',
    },
    {
      id: 'stats',
      target: 'dashboard-stats',
      title: 'The headline numbers',
      body: 'Leads in your pipeline, your reply rate, meetings booked, and the engagement on your posts.',
    },
    {
      id: 'funnel',
      target: 'dashboard-funnel',
      title: 'Your outreach funnel',
      body: 'Each stage from first contact to reply, with the share of people who moved from one stage to the next.',
    },
    {
      id: 'quick-actions',
      target: 'dashboard-quick-actions',
      title: 'Start here',
      body: 'Jump straight into finding leads, creating a campaign, or drafting a post.',
    },
    {
      id: 'activity',
      target: 'dashboard-activity',
      title: 'Recent activity',
      body: 'A live log of every action your automation takes, newest first.',
    },
    {
      id: 'done',
      title: 'That is the Dashboard',
      body: 'Reopen this walkthrough anytime from the Help button.',
    },
  ],
}
